import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useTranslation } from 'react-i18next'

export const DailyAttendanceChart = ({ days }) => {
    const { t } = useTranslation()

    const categories = days.map((d) => d.date)
    const daySeries = days.map((d) => Number(d.day_primary || 0))
    const nightSeries = days.map((d) => Number(d.night_primary || 0))
    const unknownSeries = days.map((d) => Number(d.unknown_primary || 0))
    const extrasSeries = days.map((d) => Number(d.extras_ops || 0))

    const hasUnknown = unknownSeries.some((v) => v > 0)

    const series = [
        { name: t('workforce.analytics.series_day'), data: daySeries, color: '#eab308', stack: 'attendance' },
        { name: t('workforce.analytics.series_night'), data: nightSeries, color: '#6366f1', stack: 'attendance' },
    ]
    if (hasUnknown) {
        series.push({ name: t('workforce.analytics.series_unknown'), data: unknownSeries, color: '#9ca3af', stack: 'attendance' })
    }
    series.push({ name: t('workforce.analytics.series_extras'), data: extrasSeries, color: '#fb923c', stack: 'extras' })

    const options = {
        chart: { type: 'column', height: 320 },
        title: { text: null },
        xAxis: { categories, tickmarkPlacement: 'on', lineColor: '#e5e7eb' },
        yAxis: {
            min: 0,
            title: { text: t('workforce.analytics.axis_operators') },
            allowDecimals: false,
            gridLineColor: '#f3f4f6',
        },
        legend: { align: 'right', verticalAlign: 'top' },
        tooltip: {
            shared: true,
            valueDecimals: 0,
        },
        plotOptions: {
            column: { stacking: 'normal', borderWidth: 0, pointPadding: 0.05, groupPadding: 0.1 },
        },
        series,
        credits: { enabled: false },
    }

    return <HighchartsReact highcharts={Highcharts} options={options} />
}
